import clsx from '@packages/clsx';
import type { FC } from 'react';
import { withDeviceType } from '../../hocs/withDeviceType';
import styles from './GlobalSpinner.module.scss';
import {
	type GlobalSpinnerSize,
	GlobalSpinnerSizeMapping,
} from './GlobalSpinnerSizeMapping';

export interface GlobalSpinnerProps {
	size:
		| GlobalSpinnerSize
		| {
				width: number;
				height: number;
		  };
}
export const GlobalSpinner: FC<GlobalSpinnerProps> = withDeviceType((props) => {
	const { deviceType, size } = props;
	const classes = clsx(
		styles.globalSpinner,
		typeof size === 'string' ? GlobalSpinnerSizeMapping[size] : '',
		{
			[styles.desktop]: deviceType === 'desktop',
			[styles.mobile]: deviceType === 'mobile',
			[styles.tablet]: deviceType === 'tablet',
		},
	);
	return (
		<div className={classes}>
			<svg
				className={styles.pl}
				width='0px'
				height='0px'
				viewBox='0 0 128 128'
			>
				<title>loader</title>
				<circle
					className={styles.ring1}
					cx='64'
					cy='64'
					r='60'
					fill='none'
					stroke='#FF3434'
					strokeWidth='8'
					transform='rotate(-90,64,64)'
					strokeLinecap='round'
					strokeDasharray='377 377'
					strokeDashoffset='-376.4'
				/>
				<circle
					className={styles.ring2}
					cx='64'
					cy='64'
					r='52.5'
					fill='none'
					stroke='hsl(13,90%,55%)'
					strokeWidth='7'
					transform='rotate(-90,64,64)'
					strokeLinecap='round'
					strokeDasharray='329.9 329.9'
					strokeDashoffset='-329.3'
				/>
				<circle
					className={styles.ring3}
					cx='64'
					cy='64'
					r='46'
					fill='none'
					stroke='#FF5B29'
					strokeWidth='6'
					transform='rotate(-90,64,64)'
					strokeLinecap='round'
					strokeDasharray='289 289'
					strokeDashoffset='-288.6'
				/>
				<circle
					className={styles.ring4}
					cx='64'
					cy='64'
					r='40.5'
					fill='none'
					stroke='hsl(33,90%,55%)'
					strokeWidth='5'
					transform='rotate(-90,64,64)'
					strokeLinecap='round'
					strokeDasharray='254.5 254.5'
					strokeDashoffset='-254'
				/>
				<circle
					className={styles.ring5}
					cx='64'
					cy='64'
					r='36'
					fill='none'
					stroke='hsl(43,90%,55%)'
					strokeWidth='4'
					transform='rotate(-90,64,64)'
					strokeLinecap='round'
					strokeDasharray='226.2 226.2'
					strokeDashoffset='-225.8'
				/>
				<circle
					className={styles.ring6}
					cx='64'
					cy='64'
					r='32.5'
					fill='none'
					stroke='hsl(53,90%,55%)'
					strokeWidth='3'
					transform='rotate(-90,64,64)'
					strokeLinecap='round'
					strokeDasharray='204.2 204.2'
					strokeDashoffset='-203.9'
				/>
			</svg>
		</div>
	);
});
